import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FallaufgabeLernbegleiter, FallaufgabeLernbegleiterTeilaufgabeTable, TableEntryAdmin, TeilaufgabenSolutionStandard, TeilaufgabenSolutionTable } from '@reflact/ipkv-types';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TableModule } from "primeng/table";
import { Api } from '../../api';
import { OutroService } from '../../outro/outro.service';
import { ChatService } from '../chat/chat.service';
import { SubmitSolutionService } from '../submit-solution.service';

@Component({
  selector: 'app-solutions',
  standalone: true,
  imports: [
    CheckboxModule,
    ButtonModule,
    ConfirmDialogModule,
    TableModule,
    CommonModule
  ],
  templateUrl: './solutions.component.html',
  styleUrl: './solutions.component.scss',
})
export class SolutionsComponent {
  protected api = inject(Api);
  protected chatService = inject(ChatService);
  protected router = inject(Router);
  protected outroService = inject(OutroService);
  protected submitService = inject(SubmitSolutionService)
  protected confirmationService = inject(ConfirmationService);

  protected getAnswer(teilaufgabenId: string): string | null {
    const solution = this.api.solutions.value.find(s => s.teilaufgabenId == teilaufgabenId) as TeilaufgabenSolutionStandard | TeilaufgabenSolutionTable | null;
    if (solution) {
      if (solution.type === 'standard') return solution.answers.join(", ") ?? null;
      return 'Tabellenaufgabe befüllt'
    }
    return null;
  }

  protected getSortedTeilaufgaben(aIndex: number): FallaufgabeLernbegleiter['aufgaben'][number]['teilaufgaben'] {
    const aufgabe = this.api.fallaufgabe?.aufgaben[aIndex];
    if (!aufgabe) return [];
    return [...aufgabe.teilaufgaben].sort((a, b) => a.teilaufgabenIndex - b.teilaufgabenIndex);
  }

  protected confirmSubmit(event: Event) {
    this.confirmationService.confirm({
      target: event.currentTarget as EventTarget,
      message: 'Diese Aktion kann nicht Rückgängig gemacht werden. Jetzt final abgeben?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Final abgeben',
      rejectLabel: "Abbrechen",
      rejectButtonProps: {
        severity: 'secondary'
      },
      acceptButtonProps: {
        severity: 'danger'
      },
      accept: async () => {
        await this.api.submitFallaufabe();
        this.outroService.navigateToOutro(this.outroService.OUTRO_REASON_USERSUBMIT);
      },
      reject: () => { }
    });
  }

  protected closeSolutionView() {
    this.submitService.solutionsVisible = false;
  }

  protected getTableData(aIndex: number, teilaufgabenId: string) {
    const data: TableEntryAdmin[][] = [];
    if (this.api.fallaufgabe) {
      const aufgabe = this.api.fallaufgabe.aufgaben[aIndex];
      const teilaufgabe = aufgabe.teilaufgaben.find(ta => ta._id == teilaufgabenId) as FallaufgabeLernbegleiterTeilaufgabeTable | undefined;
      if (!teilaufgabe) return;
      data.push(...teilaufgabe.table);
      const solution = this.api.solutions.value.find(s => s.teilaufgabenId == teilaufgabe._id && s.type == "table") as TeilaufgabenSolutionTable | null;
      if (!solution) return;
      for (const [row, answer] of solution.answers.entries()) {
        if (answer !== null) {
          for (const [col, item] of answer.entries()) {
            if (item !== null) {
              if (data[row][col].isEditable) {
                data[row][col].solution = item;
              }
            }
          }
        }
      }
    }
    return data;
  }

  protected onQuestionCopy(teilaufgabenId: string, aufgabenId: string) {
    void this.api.trackCopyEvent(teilaufgabenId, aufgabenId, 'frage');
  }
}
